/**
 * --------------------------------------------------------------------------
 * Genesis Tabs (v1.0.0):
 * Licensed under WTFPL
 * --------------------------------------------------------------------------
 */
window.$ = window.$ ? window.$ : window.jQuery


const GenesisTabs = (($) => {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  
  const NAME = 'genesis_tabs'
  const VERSION = '1.0.0'
  const DATA_KEY = 'genesis_tabs'
  const JQUERY_NO_CONFLICT = $.fn[NAME]
  
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  
  class GenesisTabs {
    constructor (element) {
      this._element = $(element)
      this._nav = this._element.find('.genesis-tabs-nav')
      this._content = this._element.find('.genesisTabs__Box')
      
      this.init()
    }
    
    init () {
      this._content.find('img').attr('srcset', '')
      
      //  init
      this._content.on('init', () => {
        this._nav.children().eq(0).addClass('active')
        
        this._nav.children().click(ev => {
          let oTarget = ev.currentTarget
          let index = $(oTarget).index()
          this._content.slick('slickGoTo', index)
          
          ev.preventDefault()
        })
      })
      
      //   before change
      this._content.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        this._nav.children().eq(nextSlide).addClass('active').siblings().removeClass('active')
      })
      
      //  call slick
      this._content.slick({
        infinite: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-arrow genesis-tab-btn genesis-tab-btn-prev"><span class="icon-arrow_left"></span></button>',
        nextArrow: '<button class="slick-arrow genesis-tab-btn genesis-tab-btn-next"><span class="icon-arrow_right"></span></button>'
      })
      
    }
    
    // Static
    
    static _jQueryInterface () {
      return this.each(function () {
        const $element = $(this)
        let data = $element.data(DATA_KEY)
        
        if (!data) {
          data = new GenesisTabs(this)
          $element.data(DATA_KEY, data)
        }
        
      })
    }
    
  }
  
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(() => GenesisTabs._jQueryInterface.call($('.genesisTabs')))
  
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  
  $.fn[NAME] = GenesisTabs._jQueryInterface
  $.fn[NAME].Constructor = GenesisTabs
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT
    return GenesisTabs._jQueryInterface
  }
  
  return GenesisTabs
})($)

export default GenesisTabs
